<template>
  <div class="profile-share-container has-dy">
    <div class="top">
      <div class="lft">
        <template v-if="isVico">
          <img class="logo logo-vico" src="../assets/vico.png" alt="">
          <div class="info">
            <div class="t">VICO</div>
            <div class="desc">
              Socialize in a video way
            </div>
          </div>
        </template>
        <template v-else-if="isLite">
          <img class="logo" src="../assets/kimy.png" alt="">
          <div class="info">
            <div class="t">Kimy</div>
            <div class="desc">
              Socialize in a video way
            </div>
          </div>
        </template>
        <template v-else>
          <img class="logo" src="../assets/mico.png" alt="">
          <div class="info">
            <div class="t">MICO</div>
            <div class="desc">
              Socialize in a video way
            </div>
          </div>
        </template>
      </div>
      <div class="download" @click="linkToProfileByOneLink">
        {{ text[`key3`] }}
      </div>
    </div>
    <div class="swiper-container">
      <img v-if="profile.isLive" @click="linkToProfileByOneLink" class="live" src="../assets/live.gif">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in ([profile?.avatar, ...profile?.photowall])" :key="index">
          <div v-if="index > 0" class="bg bg-blur">
            <div class="download" @click="linkToProfileByOneLink">
              {{ ctaText }}
            </div>
          </div>
          <img :src="`//thumbnail-large.${topDomain}/${item}`" class="company-pic" alt=""
            onerror="this.src = this.src.replace('thumbnail-large', 'image'); this.onerror = null;">
        </div>
      </div>
      <div class="swiper-pagination" v-if="[profile?.avatar, ...profile?.photowall].length > 1"></div>
    </div>
    <div class="profile-content">
      <audioComp v-if="profile?.audioIntro" :recordFile="`/pub/share/user/audio/${profile?.audioIntro}`"></audioComp>
      <img class="avatar" @click="linkToProfileByOneLink" :src="`//thumbnail-small.${topDomain}/${profile?.avatar}`"
        alt="" onerror="this.src = this.src.replace('thumbnail-small', 'image'); this.onerror = null;">
      <div class="p-t" @click="linkToProfileByOneLink">
        <div class="nickname">{{ profile?.displayName }}</div>
        <div :class="`age ${profile?.gendar !== 1 ? `male` : `female`}`">
          <img :src="require(`../assets/${profile?.gendar !== 1 ? 'male' : 'female'}.png`)" alt="" />
          <span>{{ profile?.age }}</span>
        </div>
      </div>
      <div class="id" @click="linkToProfileByOneLink">ID: {{ profile?.userId }}</div>
      <div class="intro">{{ profile?.description }}</div>
    </div>
    <div class="moment-container">
      <div class="m-t">Moments</div>
      <div class="empty" v-if="!profile.circle">
        <img class="ic-empty" src="../assets/ic_feed_null.png" alt="">
        <span>{{ text['key4'] }}</span>
      </div>
      <div class="moment-item" v-else>
        <div class="m-top" @click="linkToProfileByOneLink">
          <img class="avatar" :src="`//thumbnail-small.${topDomain}/${profile?.avatar}`" alt="" />
          <div class="rht">
            <div class="nickname">{{ profile?.displayName }}</div>
            <div :class="`age ${profile?.gendar !== 1 ? `male` : `female`}`">
              <img :src="require(`../assets/${profile?.gendar !== 1 ? 'male' : 'female'}.png`)" alt="" />
              <span>{{ profile?.age }}</span>
            </div>
          </div>
        </div>
        <div class="m-bot">
          <div class="dy-text">{{ profile?.circle?.text }}</div>
          <div class="img-box" :style="{ height: boxHeight }">
            <div class="img-item" :style="{ width: itemWidth, height: itemHeight }" v-for="index of filledSize"
              :key="index">
              <img v-if="profile?.circle?.fids?.[index - 1]" class="dy-image"
                :src="`//thumbnail-${filledSize <= 2 ? 'large' : 'middle'}.${topDomain}/${profile?.circle?.fids?.[index - 1]}`"
                alt=""
                onerror="this.src = this.src.replace(/thumbnail-(middle|large)/, 'image'); this.onerror = null;" />
              <div class="dy-image" v-else></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fix-bot" @click="linkToProfileByOneLink">
      <div class="link" @click="linkToProfileByOneLink">
        <span>
          {{ ctaText }}
        </span>
        <img class="ic-arrow" src="../assets/ic_arrow.png" alt="">
      </div>
      <div class="btn-share">
        <div class="like">
          <img src="../assets/ic_like.png" alt="">
          <div class="placeholder"></div>
          <span>like</span>
        </div>
        <div class="chat">
          <img src="../assets/ic_chat.png" alt="">
          <div class="placeholder"></div>
          <span>Chat</span>
        </div>
        <div class="follow">
          <img src="../assets/ic_add.png" alt="">
          <div class="placeholder"></div>
          <span>Follow</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import audioComp from './audio.vue'
export default {
  components: {
    audioComp
  },
  data() {
    return {
      isLite: window._isLite,
      isVico: window._isVico,
      profile: window._profile,
      timer: 0,
    }
  },
  computed: {
    itemWidth() {
      if (this?.profile?.circle?.fids?.length >= 3) {
        return '1.1rem'
      } else {
        return '1.65rem'
      }
    },
    itemHeight() {
      if (this?.profile?.circle?.fids?.length >= 3) {
        return '1.1rem'
      } else {
        return '1.65rem'
      }
    },
    boxHeight() {
      const length = this?.profile?.circle?.fids?.length
      if (length > 6) {
        return '3.5rem'
      } else if (length > 3) {
        return '2.35rem'
      } else {
        return '1.65rem'
      }
    },
    filledSize() {
      const length = this?.profile?.circle?.fids?.length
      return length > 3 ? Math.ceil(length / 3) * 3 : length
    },
    text() {
      return window._text
    },
    ctaText() {
      const raw = (this.text && this.text['key5']) || ''
      if (this.isLite) return raw.replace(/mico(\s+lite)?/i, 'Kimy')
      return raw
    },
    topDomain() {
      if (/^(localhost|\d+\.\d+\.\d+\.\d+)$/.exec(location.hostname)) {
        return this.isVico ? 'nbnbfc.net' : 'micoworld.net'
      } else {
        return location.hostname.split('.').slice(-2).join('.')
      }
    },
    webDp() {
      return encodeURIComponent(`${location.protocol}//${location.host}`)
    },
  },
  methods: {
    linkToProfileByOneLink() {
      if (this.isVico) {
        // TODO: 替换为 VICO 独立的 onelink 短链与包名，当前与 vico home 页策略一致，沿用 mico app 引流
        location.href = `https://mico.onelink.me/O5Dq?pid=ShareProfile&af_dp=micoweb%3A%2F%2Fcom.mico%2Fuser%2Fprofile%3Fuid%3D${this.profile?.uid}`
      } else if (this.isLite) {
        location.href = `https://micolite.onelink.me/5acY?pid=ShareProfile&af_dp=micoliteweb%3A%2F%2Fcom.mico%2Fuser%2Fprofile%3Fuid%3D${this.profile?.uid}`
      } else {
        location.href = `https://mico.onelink.me/O5Dq?pid=ShareProfile&af_dp=micoweb%3A%2F%2Fcom.mico%2Fuser%2Fprofile%3Fuid%3D${this.profile?.uid}`
      }
    },
    getAge(birthday) {
      //出生时间 毫秒
      var birthDayTime = new Date(birthday).getTime()
      //当前时间 毫秒
      var nowTime = new Date().getTime()
      //一年毫秒数(365 * 86400000 = 31536000000)
      return Math.floor((nowTime - birthDayTime) / 31536000000)
    }
  },
  mounted() {
    // console.log('text', this.text)
    new Swiper('.swiper-container', {
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      pagination: {
        el: '.swiper-pagination'
      }
    })
    this.$set(
      this.profile,
      'age',
      this.getAge(this.profile?.birthday)
    )
    // this.languages = window.languages.filter(item => {
    //   if (item.value === window.document.documentElement.lang) {
    //     this.language = item
    //   } else {
    //     return true
    //   }
    // })
  }
}
</script>
<style lang="less">
@import '../css/index.less';
</style>
